<form [formGroup]="prepaidCodeForm" (submit)="onPrepaidCodeFormSubmit()">
  <div class="p-grid marginzero p-justify-center">
    <div class="p-col-12 p-sm-8 p-md-6">
      <span class="ui-float-label">
        <input id="prepaid-code" formControlName="code" name="code" type="text" pInputText style="width: 100%;">
        <label for="prepaid-code">{{ 'prepaid_code' | translate }}</label>
      </span>

      <!-- <p *ngIf="prepaidCodeForm.invalid" class="errorMessage">{{ 'prepaid_code_invalid_length' | translate }}</p> -->
    </div>
  </div>

  <div class="p-grid marginzero p-justify-center">
    <div class="p-col-6 p-sm-4 p-md-3">
      <button pButton type="submit" label="{{ 'prepaid_recharge' | translate }}" [disabled]="prepaidCodeForm.invalid" class="ui-button-info" style="width:100%"></button>
    </div>
  </div>
</form>
